import React from 'react';
import AITryOnDemo from 'shared/components/VirtualTryOn/AITryOnDemo';

const AITryOn = () => {
  return <AITryOnDemo showTitle={true} />;
};

export default AITryOn;
